export const products = [
  {
    id: 1,
    name: "Chanel No. 5",
    price: 99.99,
    image: "https://images.unsplash.com/photo-1541643600914-78b084683601?w=400",
    description: "A classic floral fragrance by Chanel. Features May Rose, Jasmine, and Aldehydes with a warm vanilla base.",
    category: "Floral",
    onSale: true,
    originalPrice: 99.99,
    salePrice: 79.99
  },
  {
    id: 2,
    name: "Dior Sauvage",
    price: 89.99,
    image: "https://images.pexels.com/photos/8501676/pexels-photo-8501676.jpeg?w=400",
    description: "A fresh and bold masculine scent with Calabrian bergamot and ambroxan. Perfect for the modern, sophisticated man.",
    category: "Fresh",
    onSale: false,
    originalPrice: 89.99,
    salePrice: 89.99
  },
  {
    id: 3,
    name: "Jo Malone London",
    price: 129.99,
    image: "https://images.unsplash.com/photo-1543422018-9a1c40cf955d?w=400",
    description: "English Pear & Freesia Cologne with notes of King William Pear. Wrapped in the scent of white freesias on a base of patchouli.",
    category: "Floral",
    onSale: true,
    originalPrice: 129.99,
    salePrice: 99.99
  },
  {
    id: 4,
    name: "Tom Ford Black Orchid",
    price: 149.99,
    image: "https://images.unsplash.com/photo-1590736704728-f4730bb30770?w=400",
    description: "A luxurious oriental fragrance with black truffle and ylang-ylang. Enhanced with dark chocolate, patchouli, and vanilla notes.",
    category: "Oriental",
    onSale: false,
    originalPrice: 149.99,
    salePrice: 149.99
  },
  {
    id: 5,
    name: "Gucci Bloom",
    price: 79.99,
    image: "https://images.unsplash.com/photo-1619994403073-2cec844b8e63?w=400",
    description: "A rich floral blend featuring Rangoon Creeper, jasmine, and tuberose. Creates an unforgettable white floral signature scent.",
    category: "Floral",
    onSale: false,
    originalPrice: 79.99,
    salePrice: 79.99
  },
  {
    id: 6,
    name: "YSL Black Opium",
    price: 109.99,
    image: "https://images.unsplash.com/photo-1563170351-be82bc888aa4?w=400",
    description: "An addictive coffee and vanilla scent with white flowers. The perfect balance of sweet, sexy, and energetic notes.",
    category: "Oriental",
    onSale: false,
    originalPrice: 109.99,
    salePrice: 109.99
  },
  {
    id: 7,
    name: "Acqua di Gio",
    price: 85.99,
    image: "https://images.pexels.com/photos/4736017/pexels-photo-4736017.jpeg??w=400",
    description: "A fresh aquatic fragrance inspired by the Mediterranean sea. Blends marine notes with bergamot, neroli, and jasmine.",
    category: "Fresh",
    onSale: false,
    originalPrice: 85.99,
    salePrice: 85.99
  },
  {
    id: 8,
    name: "Terre d'Hermès",
    price: 120.99,
    image: "https://images.pexels.com/photos/14596575/pexels-photo-14596575.jpeg?w=400",
    description: "A woody and earthy scent with orange, pepper, and vetiver. Celebrates the relationship between man and earth.",
    category: "Woody",
    onSale: false,
    originalPrice: 120.99,
    salePrice: 120.99
  },
  {
    id: 9,
    name: "Light Blue",
    price: 75.99,
    image: "https://images.pexels.com/photos/15328478/pexels-photo-15328478/free-photo-of-blonde-woman-with-perfume-flask.jpeg?w=400",
    description: "A refreshing citrus blend with Sicilian lemon and Granny Smith apple. Balanced with bamboo and cedar for a Mediterranean feel.",
    category: "Citrus",
    onSale: false,
    originalPrice: 75.99,
    salePrice: 75.99
  },
  {
    id: 10,
    name: "Versace Eros",
    price: 95.99,
    image: "https://images.unsplash.com/photo-1585386959984-a4155224a1ad?w=400",
    description: "A fresh and vibrant masculine fragrance with mint and green apple. Enriched with tonka bean, amber, and vanilla notes.",
    category: "Fresh",
    onSale: false,
    originalPrice: 95.99,
    salePrice: 95.99
  },
  {
    id: 11,
    name: "Miss Dior",
    price: 135.99,
    image: "https://images.unsplash.com/photo-1547887537-6158d64c35b3?w=400",
    description: "A romantic floral bouquet centered around Grasse Rose. Complemented by fresh lily-of-the-valley and sensual woody notes.",
    category: "Floral",
    onSale: false,
    originalPrice: 135.99,
    salePrice: 135.99
  },
  {
    id: 12,
    name: "Armani Privé Rose d'Arabie",
    price: 255.99,
    image: "https://images.unsplash.com/photo-1592945403244-b3fbafd7f539?w=400",
    description: "An opulent oriental rose fragrance with Damascus Rose and saffron. Deepened with patchouli, dark woods, and golden amber.",
    category: "Oriental",
    onSale: false,
    originalPrice: 255.99,
    salePrice: 255.99
  },
  {
    id: 13,
    name: "Byredo Gypsy Water",
    price: 189.99,
    image: "https://images.unsplash.com/photo-1506915925765-ed31516b9080?w=400",
    description: "A woody aromatic fragrance",
    category: "Woody",
    onSale: false,
    originalPrice: 189.99,
    salePrice: 189.99
  },
  {
    id: 14,
    name: "Creed Aventus",
    price: 325.99,
    image: "https://images.pexels.com/photos/8450339/pexels-photo-8450339.jpeg?auto=compress&w=400",
    description: "A fruity and rich masculine scent",
    category: "Fresh",
    onSale: false,
    originalPrice: 325.99,
    salePrice: 325.99
  },
  {
    id: 15,
    name: "Le Labo Santal 33",
    price: 215.99,
    image: "https://images.unsplash.com/photo-1585386959984-a4155224a1ad?w=400",
    description: "A distinctive woody aromatic",
    category: "Woody",
    onSale: false,
    originalPrice: 215.99,
    salePrice: 215.99
  },
  {
    id: 16,
    name: "Maison Francis Kurkdjian Baccarat Rouge 540",
    price: 325.99,
    image: "https://images.unsplash.com/photo-1512777576244-b846ac3d816f?w=400",
    description: "A luxurious amber floral fragrance",
    category: "Oriental",
    onSale: false,
    originalPrice: 325.99,
    salePrice: 325.99
  },
  {
    id: 17,
    name: "Atelier Cologne Orange Sanguine",
    price: 135.99,
    image: "https://images.pexels.com/photos/8450541/pexels-photo-8450541.jpeg?auto=compress&w=400",
    description: "A zesty citrus explosion",
    category: "Citrus",
    onSale: false,
    originalPrice: 135.99,
    salePrice: 135.99
  },
  {
    id: 18,
    name: "Frederic Malle Portrait of a Lady",
    price: 255.99,
    image: "https://images.unsplash.com/photo-1592945403244-b3fbafd7f539?w=400",
    description: "A sophisticated rose oriental",
    category: "Oriental",
    onSale: false,
    originalPrice: 255.99,
    salePrice: 255.99
  },
  {
    id: 19,
    name: "Diptyque Philosykos",
    price: 175.99,
    image: "https://images.unsplash.com/photo-1589820933944-1ec1ae95b089?w=400",
    description: "A fresh fig woody fragrance",
    category: "Woody",
    onSale: false,
    originalPrice: 175.99,
    salePrice: 175.99

  },
  {
    id: 20,
    name: "Acqua di Parma Fico di Amalfi",
    price: 145.99,
    image: "https://images.pexels.com/photos/8450530/pexels-photo-8450530.jpeg?w=400",
    description: "A Mediterranean citrus delight",
    category: "Citrus",
    onSale: false,
    originalPrice: 145.99,
    salePrice: 145.99
  },
  {
    id: 21,
    name: "Penhaligon's Empressa",
    price: 215.99,
    image: "https://images.unsplash.com/photo-1592945403244-b3fbafd7f539?w=400",
    description: "A fruity-floral oriental blend",
    category: "Oriental",
    onSale: false,
    originalPrice: 215.99,
    salePrice: 215.99
  },
  {
    id: 22,
    name: "Clive Christian No.1",
    price: 550.99,
    image: "https://images.unsplash.com/photo-1591375275773-59691a15defa?w=400",
    description: "The world's most expensive perfume",
    category: "Floral",
    onSale: false,
    originalPrice: 550.99,
    salePrice: 550.99
  },
  {
    id: 23,
    name: "Roja Dove Elysium",
    price: 375.99,
    image: "https://images.unsplash.com/photo-1594035910387-fea47794261f?w=400",
    description: "A fresh citrus masculine fragrance",
    category: "Fresh",
    onSale: false,
    originalPrice: 375.99,
    salePrice: 375.99
  },
  {
    id: 24,
    name: "Amouage Reflection Man",
    price: 325.99,
    image: "https://images.unsplash.com/photo-1585386959984-a4155224a1ad?w=400",
    description: "A sophisticated woody floral musk",
    category: "Woody",
    onSale: false,
    originalPrice: 325.99,
    salePrice: 325.99
  },
  {
    id: 25,
    name: "Bond No. 9 New York Oud",
    price: 285.99,
    image: "https://images.unsplash.com/photo-1592945403244-b3fbafd7f539?w=400",
    description: "A modern oriental oud fragrance",
    category: "Oriental",
    onSale: true,
    originalPrice: 285.99,
    salePrice: 205.99
  },
  {
    id: 26,
    name: "Kilian Angels' Share",
    price: 295.99,
    image: "https://images.unsplash.com/photo-1590156221187-1710315f710b?w=400",
    description: "A warm cognac-inspired scent",
    category: "Oriental",
    onSale: false,
    originalPrice: 295.99,
    salePrice: 295.99
  },
  {
    id: 27,
    name: "Xerjoff Naxos",
    price: 265.99,
    image: "https://images.pexels.com/photos/6954639/pexels-photo-6954639.jpeg?w=400",
    description: "A honey tobacco oriental blend",
    category: "Oriental",
    onSale: true,
    originalPrice: 265.99,
    salePrice: 165.99
  },
  {
    id: 28,
    name: "Memo Paris French Leather",
    price: 245.99,
    image: "https://images.unsplash.com/photo-1585386959984-a4155224a1ad?w=400",
    description: "A sophisticated leather fragrance",
    category: "Woody",
    onSale: true,
    originalPrice: 245.99,
    salePrice: 225.99
  },
  {
    id: 29,
    name: "Parfums de Marly Delina",
    price: 325.99,
    image: "https://images.unsplash.com/photo-1592945403244-b3fbafd7f539?w=400",
    description: "A luxurious floral bouquet",
    category: "Floral",
    onSale: true,
    originalPrice: 325.99,
    salePrice: 125.99
  },
  {
    id: 30,
    name: "Chanel No. 5 Gift Set",
    price: 150.00,
    image: "https://images.unsplash.com/photo-1541643600914-78b084683601?w=400",
    description: "A luxurious gift set featuring the iconic Chanel No. 5 fragrance. Includes a 3.4 oz Eau de Parfum and a travel spray.",
    category: "Gift Sets",
    onSale: true,
    originalPrice: 180.00,
    salePrice: 150.00
  },
  {
    id: 31,
    name: "Dior Sauvage Gift Set",
    price: 120.00,
    image: "https://images.unsplash.com/photo-1523293182086-7651a899d37f?w=400",
    description: "A perfect gift for the modern man. This set includes a 3.4 oz Eau de Toilette and a stylish travel case.",
    category: "Gift Sets",
    onSale: false,
    originalPrice: 120.00,
    salePrice: 120.00
  },
  {
    id: 32,
    name: "Jo Malone London Gift Set",
    price: 200.00,
    image: "https://plus.unsplash.com/premium_photo-1679106770086-f4355693be1b?w=400",
    description: "A beautifully packaged gift set featuring the English Pear & Freesia Cologne and a scented candle.",
    category: "Gift Sets",
    onSale: true,
    originalPrice: 250.00,
    salePrice: 200.00
  },
  {
    id: 33,
    name: "Tom Ford Black Orchid Gift Set",
    price: 175.00,
    image: "https://plus.unsplash.com/premium_photo-1670445045282-36648e89af6b?w=400",
    description: "An elegant gift set that includes a 3.4 oz Eau de Parfum and a luxurious body lotion.",
    category: "Gift Sets",
    onSale: false
  },
  {
    id: 34,
    name: "Gucci Bloom Gift Set",
    price: 130.00,
    image: "https://images.unsplash.com/photo-1591375462077-800a22f5fba4?w=400",
    description: "A delightful gift set featuring the Gucci Bloom fragrance and a travel-sized version.",
    category: "Gift Sets",
    onSale: true,
    originalPrice: 160.00,
    salePrice: 130.00
  }
];
